import React from "react";

export default class Found extends React.Component {
  render() {
    return (
      <>
        <h2>If you find someone</h2>
        <h3>Symptoms:</h3>
        <p>
          A person lying in a non typical space, far from the party (stages or
          chillout), especially if laying suspine.{" "}
        </p>
        <h3>What to do?</h3>
        <p>
          Most important is your safety. Secure the place of the incident and
          make sure, that nothing is threathening you (high voltage cables,
          pieces of glass, agressive people or animals etc.){" "}
        </p>
        <h4>Assess counciousness</h4>
        <p>
          Kneel side by side the person laying, lightly shake the shoulders and
          ask loudly 'what happened'. You can check the reaction for pain by
          pressuring strongly the hollow spot on the shoulder right above the
          collarbone.{" "}
        </p>
        <h4>If doesn't react, clear the airpaths nad assess breath.</h4>
        <p>
          Lay one hand on the forehead and with the fingers of the other hand
          hold the jaw bone. Softly pull back the head and move jaw up. Now with
          the help of sight, hear and touch asess if the person is breathing.
          You have 10 seconds.{" "}
        </p>
        <h4>If is breathing, but is unconcious</h4>
        <p>
          Lay in the safe position (on a side) and every 2 minutes check for
          vital life functions.{" "}
        </p>
        <h4>If is not breathing</h4>
        <p>
          Call a medical rescue team and immiedietly begin circulatory-breathing
          resuscitation (see CARDIAC ARREST)
        </p>
      </>
    );
  }
}
